import { render, staticRenderFns } from "./ArticleBodyPreview.vue?vue&type=template&id=9a4d317e&scoped=true&"
import script from "./ArticleBodyPreview.vue?vue&type=script&lang=js&"
export * from "./ArticleBodyPreview.vue?vue&type=script&lang=js&"
import style0 from "./ArticleBodyPreview.vue?vue&type=style&index=0&id=9a4d317e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4d317e",
  null
  
)

export default component.exports